import { StatusLabel } from '@/features/devices/components/StatusLabel';
import type { ContractStatus } from '../types';

// Tailwind colour classes per derived contract state.
export const contractStatusLabelStyles: Record<ContractStatus, string> = {
  Requested: 'bg-warning/15 text-warning border-warning/30',
  Active: 'bg-success/15 text-success border-success/30',
  Locked: 'bg-primary/15 text-primary border-primary/30',
  Canceled: 'bg-error/15 text-error border-error/30',
  Expired: 'bg-border text-muted border-border',
};

// ContractStatusBadge keeps older imports working while rendering the shared StatusLabel.
export function ContractStatusBadge({
  status,
  className,
}: {
  status: ContractStatus;
  className?: string;
}) {
  return (
    <StatusLabel
      status={status}
      translationPrefix="serviceContracts.status"
      styles={contractStatusLabelStyles}
      className={className}
    />
  );
}
